import { Injectable } from '@angular/core';
import { OnDevicesAPISubscription } from 'ngx-core-services';
import { ViewportScroller } from '@angular/common';
import { Router } from '@angular/router';
import { ToastService, ErrorSinkService } from 'ngx-zcs-components';

import { SolarmanService } from './solarman.service';
import { InternetChannelInstance } from './internet-channel.instance';

/**
 * Singleton Angular service for Internet (Solarman) communication.
 * Extends InternetChannelInstance for full retrocompat — existing code that injects
 * InternetService continues to work unchanged. For multi-device, use InternetChannelFactory instead.
 */
@Injectable({
  providedIn: 'root',
})
export class InternetService extends InternetChannelInstance {
  constructor(
    onDevicesAPISubscription: OnDevicesAPISubscription,
    router: Router,
    solarmanService: SolarmanService,
    toastService: ToastService,
    viewportScroller: ViewportScroller,
    errorSink: ErrorSinkService,
  ) {
    super(onDevicesAPISubscription, router, solarmanService, toastService, viewportScroller, errorSink);
  }
}
